module.exports = __webpack_public_path__ + "static/media/balance_6_수면케어.b1c90ac6.JPG";